import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const initialsFromName = (name) => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

const avatarToneFromName = (name) => {
  const tones = ["indigo", "sky", "emerald", "amber", "rose", "violet"];
  const s = String(name || "");
  let hash = 0;
  for (let i = 0; i < s.length; i += 1) hash = (hash * 31 + s.charCodeAt(i)) | 0;
  return tones[Math.abs(hash) % tones.length];
};

const AppraisalEmployeeAvatar = ({ url, name }) => {
  const [broken, setBroken] = useState(false);
  if (url && !broken) {
    return (
      <img
        src={url}
        alt=""
        className="appraisal-team-avatar__img"
        onError={() => setBroken(true)}
      />
    );
  }
  return (
    <span
      className={`appraisal-team-avatar__fallback appraisal-team-avatar__fallback--${avatarToneFromName(name)}`}
    >
      {initialsFromName(name)}
    </span>
  );
};

/** Employee cell: avatar + name + designation + office/department meta. */
export const AppraisalEmployeeCell = ({
  name,
  designation,
  department,
  officeName,
  profileImageUrl,
  showDesignation = true,
  showOrgMeta = true,
}) => {
  const { t } = useTranslation();
  const displayName = name || "—";
  const role = String(designation || "").trim();
  const dept = String(department || "").trim();
  const office = String(officeName || "").trim();
  const orgParts = [office, dept].filter(Boolean);

  return (
    <div className="appraisal-team-person">
      <div className="appraisal-team-avatar">
        <AppraisalEmployeeAvatar url={profileImageUrl} name={displayName} />
      </div>
      <div className="appraisal-team-person__text">
        <div className="appraisal-team-person__name">{displayName}</div>
        {showDesignation ? (
          <div className="appraisal-team-person__designation">
            {role ||
              t("app.appraisal.noDesignation", {
                defaultValue: "No designation",
              })}
          </div>
        ) : null}
        {showOrgMeta ? (
          <div className="appraisal-team-person__org">
            {orgParts.length
              ? orgParts.join(" · ")
              : t("app.appraisal.noOfficeDepartment", {
                  defaultValue: "No office / department",
                })}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export const pickEmployeeFields = (raw) => ({
  userName: raw?.userName ?? raw?.UserName ?? "",
  designation: raw?.designation ?? raw?.Designation ?? "",
  department: raw?.department ?? raw?.Department ?? "",
  officeName: raw?.officeName ?? raw?.OfficeName ?? "",
  profileImageUrl: String(raw?.profileImageUrl ?? raw?.ProfileImageUrl ?? "").trim() || null,
});

export default AppraisalEmployeeCell;
